import classnames from 'classnames'
import InputMask from 'react-input-mask'

export const InputMaskField = ({
  mask,
  name,
  label,
  type,
  placeholder,
  error,
  defaultValue,
  value,
  helper,
  helperDescription,
  rounded,
  className,
  filter,
  containerClassName,
  readOnly,
  onChange,
}: {
  mask: string
  name: string
  label: string
  type: 'input' | 'password' | 'number'
  placeholder?: string
  error?: string
  defaultValue?: string
  value?: string
  helper?: string
  helperDescription?: string
  options?: { name: string; value: string }[]
  rounded?: boolean
  className?: string
  filter?: boolean
  containerClassName?: string
  readOnly?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onValueChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
}): JSX.Element => {
  return (
    <div className="flex flex-col gap-2 w-full">
      {label ? (
        <label
          htmlFor={name}
          className="flex flex-col gap-2 text-sm tracking-wider font-light w-full"
        >
          <span>{label}</span>
        </label>
      ) : null}
      {helper ? (
        <label
          htmlFor={name}
          className="flex flex-col gap-2 text-sm tracking-wider font-light w-full"
        >
          <span>{helper}</span>
        </label>
      ) : null}
      <InputMask
        mask={mask}
        readOnly={readOnly}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        id={name}
        className={`block border border-gray-600 opacity-100 p-2  w-full tracking-wider rounded ${
          readOnly ? 'text-gray-100' : 'text-black'
        }`}
      />
      {/* <input
        readOnly={readOnly}
        defaultValue={defaultValue}
        onChange={onChange}
        id={name}
        type={type}
        placeholder={placeholder}
        className="block border p-2 text-black w-full tracking-wider rounded"
      /> */}
      {error ? (
        <div className={'text-red text-xs mt-1 tracking-wider'} role="alert">
          {error}
        </div>
      ) : null}
    </div>
  )
}
